export default __webpack_public_path__ + "static/apparel-showrooms-buyer-view-adfac024fe9a6b3279588fd9f161ba32.png";